import React, { useEffect, useState } from "react";
import { IInvoiceServicePosition } from "../../interfaces/IInvoiceServicePosition";
import { IconButton, TableCell, TableRow } from "@mui/material";
import { CustomeTextField } from "../core/CustomeTextField";
import { Delete, InsertPhotoSharp } from "@mui/icons-material";


interface IProps {
    invCreditPos: IInvoiceServicePosition;
    invCreditPositions: IInvoiceServicePosition[];
    setInvCreditPositions: Function;
}


export const InvoiceCreditingRow:React.FC<IProps> = ({
    invCreditPos,
    invCreditPositions,
    setInvCreditPositions
}) => {
    const [editInvCreditPos,setEditInvCreditPos] = useState(invCreditPos);

    const handleRemoveMe = () => {
        setInvCreditPositions([
            ...invCreditPositions.filter(invPos => invPos.id !== editInvCreditPos.id)
        ])
    }

    useEffect(() => {
        setInvCreditPositions([
            ...invCreditPositions.map(invPos => invPos.id === editInvCreditPos.id ? editInvCreditPos : invPos )
        ])
    },[editInvCreditPos])

    return(
        <TableRow>
            <TableCell>
                <CustomeTextField
                    attr="title"
                    label="Begründung/Titel"
                    object={editInvCreditPos}
                    setObject={setEditInvCreditPos}
                    type="string"
                />
            </TableCell>
            <TableCell>
                <CustomeTextField
                    attr="price"
                    label="Gutschrift"
                    object={editInvCreditPos}
                    setObject={setEditInvCreditPos}
                    type="euro"
                />
            </TableCell>
            <TableCell>
                <IconButton onClick={handleRemoveMe}><Delete/></IconButton>
            </TableCell>
        </TableRow>
    )
}